import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Practitioner } from './profile/models/practitioner';
import { HealthSystem } from './models/healthSystem';
import { HealthSystemCreate } from './models/healthSystemCreate';
import { HealthSystemTier } from './models/healthSystemTier';
import { CreditCardPaymentInformation, HealthSystemPaymentInformationv2 } from './models/healthSystemPaymentInformation';
import { HealthSystemPractitioner } from './profile/models/healthSystemPractitioner';
import { User } from './models/user';
import { Staff } from './models/staff';
import { Appointment } from '../core/model/v2/appointment/appointment';
import { GlobalHealthSystem } from '../core/model/v2/healthSystem/global-health-system';
import { BaseService } from '../core/services/shared/base.service';
import { Dashboard } from './models/dashboard';

@Injectable()
export class PhysicianService {

  constructor(private httpClient: HttpClient, private baseService: BaseService) { }

  baseUrl = '/api/';
  baseUrlProviders = '/api/providers';
  npibaseUrl = 'https://appyhealthapi-dev.azurewebsites.net/api/';


  getSubscriptionType(healthOrganizationId:number):Observable<any>{
    return this.baseService.get<any>('HealthOrganization/GetSubscriptionType?healthOrgId='+ healthOrganizationId);
  }

  updateSubscriptionType(healthOrganizationId:number,subscriptionType:number):Observable<any>{
    return this.baseService.get<any>('HealthOrganization/UpdateSubscriptionType?healthOrgId='+ healthOrganizationId + '&subscriptionTypeId=' + subscriptionType);
  }

  getReferralsByPractitionerId(practitionerId: number): Observable<Appointment[]> {
    //return this.httpClient.get<Appointment[]>('/api/get?url=' + 'v2/Referral/GetReferralsByPractitionerId?practitionerId=' + practitionerId);
    return this.baseService.get<Appointment[]>('Referral/GetReferralsByPractitionerId?practitionerId=' + practitionerId);
  }

  getAllPractitionersByUserId(userId: number): Observable<Practitioner[]> {
    // return this.httpClient.get<Practitioner[]>('/api/get?url=' + 'v2/User/GetAllPractitionersByUserId?userId=' + userId);
    return this.baseService.get<Practitioner[]>('User/GetAllPractitionersByUserId?userId=' + userId);
  }

  getPractitioner(id: number): Observable<Practitioner> {
    return this.httpClient.get<Practitioner>(`/api/get?url=providers/${id}`);
  }

  updatePractitioner(practitioner: Practitioner): Observable<Practitioner> {
    return this.httpClient.put<Practitioner>(`/api/put?url=providers/Update`, practitioner);
  }

  getHealthSystem(id: number): Observable<HealthSystem[]> {
    return this.httpClient.get<HealthSystem[]>(`/api/get?url=healthsystem/${id}`);
  }

  getChildHealthSystems(id: number): Observable<HealthSystem[]> {
    return this.httpClient.get<HealthSystem[]>(`/api/get?url=healthsystem/Children/${id}`);
  }

  getHealthSystemPractitioners(id: number): Observable<HealthSystemPractitioner[]> {
    return this.httpClient.get<HealthSystemPractitioner[]>(`/api/get?url=healthsystem/Practitioners/${id}`);
  }

  getMyHealthSystemPhysicians(): Observable<Practitioner[]> {
    return this.httpClient.get<Practitioner[]>(`/api/get?url=user/myassociates`);
  }

  getMyPhysicians(): Observable<Practitioner[]> {
    return this.httpClient.get<Practitioner[]>(`/api/get?url=user/myphysicians`);
  }

  getMyHealthSystemAdminUsers(healtSystemId: number): Observable<User[]> {
    return this.httpClient.get<User[]>(`/api/get?url=healthsystem/AdminUsers/${healtSystemId}`);
  }

  getMyHealthSystemNonphysicians(): Observable<Practitioner[]> {
    return this.httpClient.get<Practitioner[]>(`/api/get?url=user/mynonphysicians`);
  }

  saveHealthSystem(healthSystem: HealthSystem): Observable<HealthSystem> {
    return this.httpClient.put<HealthSystem>(`/api/put?url=healthsystem/update`, healthSystem);
  }

  updateHealthSystemLogo(providerId: number, file): Observable<any> {
    const input: FormData = new FormData();
    input.append('file', file, file.name);

    return this.httpClient.post<any>(`/api/PostForm?url=healthsystem/Photo/${providerId}`, input);
  }

  addHealthSystem(healthSystem: HealthSystemCreate): Observable<HealthSystemCreate> {
    return this.httpClient.post<HealthSystemCreate>(`/api/post?url=user/createhealthsystem`, healthSystem);
  }

  saveChildHealthSystem(id: number, childId: number): Observable<boolean> {
    return this.httpClient.put<boolean>(`/api/putnobody?url=healthsystem/Children/${id}/${childId}`, null);
  }


  getProvider(id: number): Observable<Practitioner> {
    return this.httpClient.get<Practitioner>(`/api/get?url=providers/${id}`);
  }

  saveProvider(provider: Practitioner): Observable<boolean> {
    return this.httpClient.put<boolean>(`/api/put?url=providers/Update`, provider);
  }

  addPractitioner(provider: Practitioner): Observable<Staff> {
    return this.httpClient.post<Staff>(`/api/post?url=user/create`, provider);
  }

  addLocation(healthSystem: HealthSystem): Observable<boolean> {
    return this.httpClient.post<boolean>(`/api/post?url=healthsystem/createlocation`, healthSystem);
  }

  deleteLocation(id: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`/api/delete?url=healthsystem/deletelocation/${id}`);
  }

  searchHealthSystem(npi: string): Observable<HealthSystem> {
    return this.httpClient.get<HealthSystem>(`/api/get?url=NPI/SearchNPI/2/${npi}`);
  }

  searchProvider(npi: string): Observable<Practitioner> {
    return this.httpClient.get<Practitioner>(`/api/get?url=NPI/SearchNPI/1/${npi}`);
  }

  addPractitionerToHealthSystem(healthSystemId: number, practitionerId: number): Observable<boolean> {
    return this.httpClient.put<boolean>(`/api/putnobody?url=healthsystem/AddPractitioner/${healthSystemId}/${practitionerId}`, null);
  }

  removePractitionerFromHealthSystem(healthSystemId: number, practitionerId: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`/api/delete?url=healthsystem/RemovePractitioner/${healthSystemId}/${practitionerId}`);
  }

  removeChildHealthSystem(id: number, childId: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`/api/delete?url=healthsystem/Children/${id}/${childId}`);
  }

  addUser(s: Staff): Observable<Staff> {
    return this.httpClient.post<Staff>(`/api/post?url=user/createstaff`, s);
  }

  updateStaff(s: Staff): Observable<Staff> {
    return this.httpClient.post<Staff>(`/api/post?url=user/updatestaff`, s);
  }

  updateUser(u: User): Observable<User> {
    return this.httpClient.post<User>(`/api/post?url=user/updatestaff`, u);
  }

  addUserToHealthSystem(healthSystemId: number, locationId: number, userId: number, userRoleId: number): Observable<boolean> {
    return this.httpClient.put<boolean>(`/api/putnobody?url=healthsystem/AddLocationUser/${healthSystemId}/${locationId}/${userId}/${userRoleId}`, null);
  }

  removeUserFromHealthSystem(healthSystemId: number, locationId: number, userId: number): Observable<boolean> {
    return this.httpClient.delete<boolean>(`/api/delete?url=healthsystem/RemoveLocationUser/${healthSystemId}/${locationId}/${userId}`);
  }

  uploadPhoto(file, providerId) {
    const input: FormData = new FormData();
    input.append('file', file, file.name);
    return this.httpClient.post(`/api/PostForm?url=providers/Photo/${providerId}`, input);
  }

  getTiers(): Observable<HealthSystemTier[]> {
    return this.httpClient.get<HealthSystemTier[]>(`/api/get?url=healthSystem/Tiers`);
  }

  putSubscribeTire(healthSystem: HealthSystem, tierId: number): Observable<HealthSystem> {
    return this.httpClient.put<HealthSystem>(`/api/put?url=healthsystem/SubscribeTier/${healthSystem.Id}/${tierId}`, healthSystem);
  }
  putSubscribeTier(healthSystem: GlobalHealthSystem, tierId: number): Observable<GlobalHealthSystem> {
    return this.httpClient.put<GlobalHealthSystem>(`/api/put?url=globalhealthsystem/SubscribeTier/${healthSystem.id}/${tierId}`, healthSystem);
  }

  putUpdateMyAssociates(User: User): Observable<User> {
    return this.httpClient.post<User>(`/api/post?url=user/updatestaff`, User);
  }

  updatePaymentInformation(paymentInfo: CreditCardPaymentInformation): Observable<any> {
    return this.baseService.post<any>('HealthOrganization/PaymentInformation', paymentInfo);
  }

  getPaymentInformation(): Observable<CreditCardPaymentInformation> {
    return this.baseService.get<any>('HealthOrganization/PaymentInformation');
  }
  
  getDashboardDetails(): Observable<Dashboard> {
    return this.baseService.get<Dashboard>('DashBoard/GetDashBoardDetails');
  }
}
